import { BreadcrumbsService } from './services/breadcrumbs.service';
import { BreadcrumbService } from 'ng2-breadcrumb/ng2-breadcrumb';
import { ApiService } from './services/api.service';
import { Router, Event as RouterEvent, NavigationEnd } from '@angular/router';
import { AuthService } from './services/auth.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Component, OnInit, AfterViewInit, OnChanges } from '@angular/core';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import { environment } from './../environments/environment';
import '../assets/js/scripts.js';

declare var Project: any;
declare var gtag : any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})

export class AppComponent implements OnInit, AfterViewInit, OnChanges {

  subscriber: any;

  public options = {
    timeOut: 5000,
    lastOnBottom: true,
    clickToClose: true,
    maxLength: 0,
    maxStack: 7,
    showProgressBar: true,
    pauseOnHover: true,
    preventDuplicates: false,
    preventLastDuplicates: 'visible',
    rtl: false,
    animate: 'scale',
    position: ['right', 'bottom']
  };

  public changeLanguage(language) {
    this.translate.use(language);
  }

  constructor(
    private translate: TranslateService,
    private authService: AuthService,
    private apiService: ApiService,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    private breadcrumbsService: BreadcrumbsService,
    private translateService: TranslateService,
    private idle: Idle,
  ) {
    if (!Boolean(`${environment.for_testing}`) === true) {
      this.idle.setIdle(600);
      this.idle.setTimeout(5);
      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
      this.idle.onTimeout.subscribe(() => {
        this.authService.logout();
      });
      this.idle.watch();
    }
    this.router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'UA-41462943-11', {
          page_path: event.urlAfterRedirects
        });
      }
    });
  }

  ngOnInit() {
    // LOGOWANIE I REJESTRACJA
    this.breadcrumbsService.translateBreadcrumb('/login', 'GENERAL.LOGIN');
    this.breadcrumbsService.translateBreadcrumb('/login/i', 'GENERAL.LOGIN_FOR_INVOICE');
    this.breadcrumbService.hideRouteRegex('/login/i/[a-zA-Z0-9]');
    this.breadcrumbsService.translateBreadcrumb('/login/remind', 'GENERAL.REMINDPASSWORD');
    this.breadcrumbsService.translateBreadcrumb('/login/verify', 'Weryfikacja');
    this.breadcrumbService.hideRoute('/login/%2Fcheckout%2Fsummary');
    this.breadcrumbsService.translateBreadcrumb('/register', 'GENERAL.REGISTER');
    this.breadcrumbsService.translateBreadcrumb('/company', 'Firma');
    this.breadcrumbsService.translateBreadcrumb('/company/add', 'Nowa firma');
    this.breadcrumbsService.translateBreadcrumb('/company/edit', 'Zmiana danych');
    this.breadcrumbsService.translateBreadcrumb('/company/select', 'Wybór firmy');
    this.breadcrumbsService.translateBreadcrumb('/terms', 'Warunki korzystania z serwisu');
    this.breadcrumbService.hideRoute('/password');
    this.breadcrumbsService.translateBreadcrumb('/password/reset', 'Zmiana hasła');
    this.breadcrumbService.hideRouteRegex('/password/reset/[a-zA-Z0-9]');
    this.breadcrumbsService.translateBreadcrumb('/activation', 'Aktywacja konta');
    this.breadcrumbService.hideRouteRegex('/activation/[a-zA-Z0-9]');

    // PANEL
    this.breadcrumbsService.translateBreadcrumb('/panel', 'Panel klienta');

    // DANE KONTA
    this.breadcrumbsService.translateBreadcrumb('/account', 'Konto');
    this.breadcrumbsService.translateBreadcrumb('/account/edit', 'Edycja danych konta');

    // WIADOMOSCI
    this.breadcrumbsService.translateBreadcrumb('/messages', 'Wiadomości');
    this.breadcrumbsService.translateBreadcrumb('/messages/list', 'Lista wiadomości');
    this.breadcrumbsService.translateBreadcrumb('/messages/new', 'Nowa wiadomość');
    this.breadcrumbsService.translateBreadcrumb('/messages/thread', 'Szczegóły wiadomości');
    this.breadcrumbService.hideRouteRegex('/messages/thread/[0-9]');
    this.breadcrumbService.hideRouteRegex('/messages/new\?.+');

    // KONTRAKTY
    this.breadcrumbsService.translateBreadcrumb('/contracts', 'Kontrakty');
    this.breadcrumbsService.translateBreadcrumb('/contracts/details', 'Szczegóły kontraktu');
    this.breadcrumbService.hideRouteRegex('/contracts/details/[0-9]');

    // FAKTURY I PLATNOSCI
    this.breadcrumbsService.translateBreadcrumb('/payments', 'Faktury i płatności');
    this.breadcrumbsService.translateBreadcrumb('/payments/list', 'Do zapłacenia');
    this.breadcrumbsService.translateBreadcrumb('/payments/history', 'Historia płatności');
    this.breadcrumbsService.translateBreadcrumb('/payments/status', 'Status płatności');
    this.breadcrumbsService.translateBreadcrumb('/payments/failure', 'Błąd płatności - przejdź do faktury i płatności');
    this.breadcrumbService.hideRouteRegex('/payments/status\?error=[0-9]*');
    // SERWERY
    this.breadcrumbsService.translateBreadcrumb('/server/devices', 'Sprzęt');
    this.breadcrumbsService.translateBreadcrumb('/server/ipmi', 'Dostęp do karty zarządzającej');
    this.breadcrumbService.hideRouteRegex('/server/dashboard/[0-9]*');
    this.breadcrumbService.hideRouteRegex('/server/devices/[0-9]*');
    this.breadcrumbService.hideRouteRegex('/server/ipmi/[0-9]*');

    //DOMENY
    this.breadcrumbsService.translateBreadcrumb('/domains', 'Domeny');
    this.breadcrumbsService.translateBreadcrumb('/domains/details', 'Rekordy domeny');
    this.breadcrumbService.hideRouteRegex('/domains/details/[0-9]*');

    // MONITORING
    this.breadcrumbsService.translateBreadcrumb('/monitoring', 'Monitoring');

    // AKTUALNOŚCI
    this.breadcrumbsService.translateBreadcrumb('/news', 'Aktualności');
    this.breadcrumbsService.translateBreadcrumb('/news/list', 'Lista aktualności');
    this.breadcrumbsService.translateBreadcrumb('/news/history', 'Lista historycznych aktualności');

    // CHECKOUT
    this.breadcrumbService.hideRoute('/checkout/payment/failure');

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.breadcrumbsService.translateBreadcrumb('/login', 'GENERAL.LOGIN');
      this.breadcrumbsService.translateBreadcrumb('/login/i', 'GENERAL.LOGIN_FOR_INVOICE');
      this.breadcrumbsService.translateBreadcrumb('/login/remind', 'GENERAL.REMINDPASSWORD');
      this.breadcrumbsService.translateBreadcrumb('/register', 'GENERAL.REGISTER');
    });

    // ACCEPTING
    this.breadcrumbsService.translateBreadcrumb('/accepting-regulations', 'Akceptowanie regulaminów');

    this.breadcrumbsService.translateBreadcrumb('/account/logons', 'Lista ostatnich logowań');

    this.breadcrumbsService.translateBreadcrumb(`/service/offer`, 'Lista usług');
    this.breadcrumbsService.translateBreadcrumb(`/service/offer/company`, 'Podsumowanie i wybór firmy');

  }

  ngOnChanges() {
    this.router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationEnd) {
        this.apiService.getCSRFToken();
        Project.init();
      }
    });

  }

  ngAfterViewInit() {
     this.router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationEnd) {
        this.apiService.getCSRFToken();
        Project.init();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts